import Swiper from 'swiper';

// Swiper 2up driver slider
const init = function(swiperId) {
  const swiperElement = document.querySelector(swiperId);
  const twoUpSwiper = new Swiper(swiperId, {
    grabCursor: false,
    centeredSlides: true,
    slidesPerView: 3,
    initialSlide: 1,
    preloadImages: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    allowTouchMove: true,
    keyboard: {
      enabled: true,
    },
    spaceBetween: 32,
    pagination: {
      el: '.js-swiper-2up-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.js-swiper-2up-button-next',
      prevEl: '.js-swiper-2up-button-prev',
    },
    on: {
      slideChangeTransitionStart() {
        const height = swiperElement.clientHeight;
        swiperElement.style.height = `${height}px`;
      },
      slideChangeTransitionEnd() {
        swiperElement.style.height = '';
      },
    },
    breakpoints: {
      767: {
        spaceBetween: 24,
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
      },
    },
  });
};

export default {
  init,
};
